// extracted by mini-css-extract-plugin
export default {"roomscene":"RoomScene_roomscene__1h9y+","active":"RoomScene_active__PG1OY"};